import { SignInPopup } from '@frontend/features/authentication'
import { ArrowLongLeftIcon } from '@heroicons/react/24/outline'
import logo from '@images/logo.png'
import { Button, Image } from '@nextui-org/react'
import ErrorBoundary from '@shared/ErrorBoundary'
import { __ } from '@wordpress/i18n'
import { useLayoutEffect } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'

const CheckoutTemplate = () => {
  const location = useLocation()

  // Scroll to top of page after a page transition.
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ behavior: 'instant', left: 0, top: 0 })
  }, [location.pathname])
  return (
    <ErrorBoundary>
      <Button
        as={Link}
        className="flex justify-start uppercase md:hidden"
        fullWidth
        startContent={<ArrowLongLeftIcon className="h-6 w-6" />}
        to={`/shop`}
        variant="flat"
      >
        {__('Back to shop', 'asavagroup')}
      </Button>
      <header>
        <div className="border-b px-8 py-14 md:px-16">
          <div className="grid content-center items-center gap-2 md:grid-cols-3">
            <Button
              as={Link}
              className="hidden w-fit uppercase md:flex"
              startContent={<ArrowLongLeftIcon className="h-6 w-6" />}
              to={`/shop`}
              variant="flat"
            >
              {__('Back to shop', 'asavagroup')}
            </Button>
            <div className="mx-auto inline-block text-center">
              <Image
                alt="Logo"
                classNames={{
                  img: 'w-[270px]',
                }}
                src={logo}
              />
            </div>
          </div>
        </div>
      </header>
      <main id="main">
        <Outlet />
      </main>
      <SignInPopup />
    </ErrorBoundary>
  )
}

export default CheckoutTemplate
